import styled from '../../../theme/styled-with-theme';
import { pxToRem } from '../../../styles/utils';
import { mediaQueries } from '../../../styles/media-queries';

import Link from '../../Link';

export const LinkTable = styled('div')`
  border: 1px solid black;
  display: flex;
  flex-direction: column;
  text-align: center;
  padding: ${pxToRem(16)} 0;

  ${mediaQueries.desktop} {
    padding: 0;
    flex-direction: row;
  }
`;

export const TableColumn = styled('div')`
  ${mediaQueries.desktop} {
    padding: ${pxToRem(40)} ${pxToRem(12)};
    width: 50%;
    border-right: 1px solid black;

    &:last-child {
      border-right: none;
    }
  }
`;

export const StyledLink = styled(Link)`
  display: block;
  margin: ${pxToRem(16)};
  font-size: ${pxToRem(20)};
  color: ${({ theme }) => theme.color.inlineAnchor};
  font-weight: 600;
  
  &:first-of-type {
    margin-top: 0;
  }
  
  &:last-child {
    margin-bottom: 0;
`;
